import "../productList/productList.css";
import React,{ useState, useEffect } from "react";
import Products from "../../components/Products";
import {  FiEdit } from "react-icons/all";

import { getProducts } from "../../Data/Products";

import ProductListComponent from "../../components/productListComponent";



function ProductList() {
  const [openCreateComponent, setOpenCreateComponent] = useState(false);

  const [Aproduct, setProduct] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      const ProductCollection = await getProducts();
      setProduct(
        ProductCollection.docs.map((doc) => {
          return {
            data: doc.data(),
            id: doc.id
          };
        })
      );
    };
    return fetchProducts();
  }, [Aproduct]);


  return (
    <div className="content productContent">
      <div className="bar">
        <button
          className="products-btn"
          onClick={() => setOpenCreateComponent(false)}
        >
          Product{" "}
        </button>{" "}
        <button
          className="products-btn"
          onClick={() => setOpenCreateComponent(true)}
        >
          <FiEdit />
          create{" "}
        </button>{" "}
      </div>
      <div className="divider"> </div>{" "}
      {openCreateComponent ? (
        <Products
          btnName="Create"
          titleName="Create new Product"
          submitType="Create"
          productData=""
        />
      ) : (
        Aproduct.map((products) => {
          return <ProductListComponent products={products} key={products.id} />;
        })
      )}{" "}
    </div>
  );
}

export default ProductList;
